export enum PaymentMethodEnum {
  SUPERADMIN_MERCHANT_P2C = -9,
  SUPERADMIN_MERCHANT_TARJETA_DE_DEBITO = -7,
  MERCHANT = -1,
  CHEQUE = 2,
  TARJETAS_DE_CREDITO = 3,
  TARJETAS_DE_DEBITO = 4,
  PAGO_ELECTRONICO = 5,
  EFECTIVO = 6,
  PAGO_MERCHANT_TARJETA_DE_DEBITO = 7,
  PAGO_MERCHANT_TARJETAS_DE_CREDITO = 8,
  PAGO_MERCHANT_P2C = 9,
  TRANSFERENCIA_BANCARIA_INMEDIATA = 10,
  PAGO_MOVIL_P2C = 11,
  PAGO_MOVIL_C2P = 12,
  PUNTO_DE_VENTA = 13,
  RETENCION_DE_IVA = 14,
  RETENCION_DE_ISRL = 15,
  RETENCION_DE_IMPUESTO_MUNICIPAL = 16,
  DEPOSITO = 17,
  TRANSFERENCIA = 18,
  PAGO_MOVIL_B2P_VUELTO = 19,
  VUELTO_EFECTIVO = 20,
  AJUSTE_DECIMAL = 21,
  NOTA_DE_CREDITO = 22,
  REINTEGRO = 26,
  PAGO_MERCHANT_TARJETA_CONCILIACION_MANUAL = 27,
  ZELLE = 30,
  REINTEGRO_ZELLE = 33,
  DEBITO_INMEDIATO = 34,
  CREDITO_INMEDIATO = 35,
  CREDITO_INMEDIATO_CM = 36,
  CREDITO_INMEDIATO_CUENTA = 37,
  REINTEGRO_NO_PROCESADO = 38,
}

export enum PaymentStatusEnum {
  APPROVE = 51,
  PENDING,
  REJECT,
  CANCELED,
}

export interface PaymentInterface {
  paymentID?: string;
  documentID?: string;
  documentNumber?: string;
  paymentDetailID?: string;
  proofOfPayment?: string;
  reference?: string;
  amount: number;
  paymentAmount?: number;
  igtfAmount: number;
  igtfPercentage: number;
  isRetention: boolean;
  status: number;
  paymentMethod: PaymentMethodInterface;
  clientIdentifier?: string;
  phone?: string;
  email?: string;
  bank?: string;
  otp?: string;
  destBankID?: number;
  paymentDate?: string;
  attempts?: number;
  affiliateNumber?: string;
  batchNumber?: string;
  creationUser?: string;
  creationDate?: string;
}

export interface PaymentMethodInterface {
  paymentMethodID: number;
  paymentMethodName: string;
  currencyID: number;
  bankID?: number;
  bankAccountID?: number;
  bankAccounts?: BankAccountInterface[];
}

export interface PaymentMethodDto {
  countryID: number;
  countryName: string;
  buCode: string;
  paymentMethodID: number;
  paymentMethodName: string;
  currencyID: number;
  currencySymbol: string;
  minAmount: number;
  maxAmount: number;
  banks: BankAccountInterface[];
}

export interface BankAccountInterface {
  bankID: number;
  bankCode?: string;
  bankName?: string;
  bankStatus?: number;
  bankAccountID?: number;
  accountNumber?: string;
  currencyID?: number;
}

export interface PaymentDetailsDto {
  documentID?: string;
  paymentID?: string;
  paymentDetailID?: string;
  paymentElectronicDetID?: string;
  buCodePayment?: string;
  paymentAmountBaseCurrent?: number;
  paymentMethodID?: number;
  exchangeRate?: number;
  currencyID?: number;
  bankAccountID?: number;
  bankAccountNumber?: string;
  sourceBankID?: number;
  sourceBankName?: string;
  sourceBankCode?: string;
  destinationBankID?: number;
  destinationBankName?: string;
  destinationBankCode?: string;
  referenceNum?: string;
  identificationType?: string;
  identificationNumber?: string;
  phoneNumber?: string;
  email?: string;
  attachmentID?: string;
  amount: number;
  amountBaseCurrent?: number;
  pctWithholding?: number;
  amountWithholding?: number;
  amountAppliedIGTF?: number;
  amountAppliedIGTFBaseCurr?: number;
  pctIGTFTax?: number;
  igtfAmount?: number;
  statusID: number;
  statusName?: string;
  paymentDate?: string;
  creationUser?: string;
  creationDate?: string;
  updateUser?: string;
  updateDate?: string;
  lastUpdate?: number;
}